window.FoxTheme = window.FoxTheme || {};

FoxTheme.Installments = (function () {
  const escapeHtml = (text) =>
    String(text || '').replace(
      /[&<>"']/g,
      (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
    );

  const toCents = (value) => Math.round((Number(value) || 0) * 100);

  // Minimum installment value (cents) for a given count; null when no tier covers the count.
  function minimumCents(config, count) {
    const tiers = config.minMode === 'tiers' ? (config.tiers || []).filter((tier) => tier.max > 0) : [];
    if (!tiers.length) return toCents(config.minValue);

    let closest = null;
    tiers.forEach((tier) => {
      if (tier.max >= count && (!closest || tier.max < closest.max)) closest = tier;
    });
    return closest ? toCents(closest.value) : null;
  }

  // Mirrors snippets/installments.liquid — keep both in sync.
  function calculate(price) {
    const config = FoxTheme.settings && FoxTheme.settings.installments;
    if (!config || !config.enabled || !(price > 0)) return null;

    let maxCount = 1;
    for (let count = config.max; count >= 2; count--) {
      const minCents = minimumCents(config, count);
      if (minCents !== null && price >= minCents * count) {
        maxCount = count;
        break;
      }
    }
    if (maxCount < 2) return null;

    const interestFreeCount = Math.min(config.interestFree, maxCount);
    const rate = Number(config.interestRate) || 0;
    let count = maxCount;
    let interestFree = true;

    if (rate > 0) {
      if (config.display === 'max' && maxCount > interestFreeCount) {
        interestFree = false;
      } else if (interestFreeCount >= 2) {
        count = interestFreeCount;
      } else {
        interestFree = false;
      }
    }

    if (interestFree) return { count, interestFree, amount: Math.round(price / count) };

    // Tabela Price: PMT = P * i * (1 + i)^n / ((1 + i)^n - 1)
    const monthlyRate = rate / 100;
    const growth = Math.pow(1 + monthlyRate, count);
    return { count, interestFree, amount: Math.round((price * monthlyRate * growth) / (growth - 1)) };
  }

  function update(container, price) {
    const element = container && container.querySelector('[data-installments]');
    if (!element) return;

    const result = calculate(price);
    element.classList.toggle('hidden', !result);
    if (!result) {
      element.innerHTML = '';
      return;
    }

    const config = FoxTheme.settings.installments;
    const template = result.interestFree ? config.textFree : config.textInterest;
    const value = `<span class="f-price__installments-value">${FoxTheme.Currency.formatMoney(
      result.amount,
      config.moneyFormat
    )}</span>`;
    element.innerHTML = escapeHtml(template).split('[parcelas]').join(result.count).split('[valor]').join(value);
  }

  return { calculate, update };
})();
